import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Radio, Typography, SpacerVertical } from '@klarna/bubble-ui';

import { translator } from 'mage-i18n';

import { Column, Row } from 'mage-components';
import { ErrorMessage } from './ErrorMessage';

export const Toggle = ({
  t,
  toggleOnChange,
  toggleValue,
  label,
  yesLabel = '',
  noLabel = '',
  isDisabled = false,
  error,
}) => {
  const radioValue = toggleValue === true ? 'yes' : toggleValue === false ? 'no' : '';

  return (
    <>
      <Row alignItems="center">
        {label && (
          <Column columns={{ desktop: 6, tablet: 8, mobile: 12 }}>
            <Typography textToken="text-style/text/labels/body/bold">{label}</Typography>
          </Column>
        )}
        <Column columns={{ desktop: 3, tablet: 2, mobile: 6 }}>
          <Radio
            error={error}
            omitFirstLine
            omitLastLine
            id="radio_yes"
            onChange={() => toggleOnChange(true)}
            value={radioValue}
            options={[
              {
                disabled: isDisabled,
                value: 'yes',
                label: yesLabel || t('products-fe.general.yes'),
              },
            ]}
          />
        </Column>
        <Column columns={{ desktop: 3, tablet: 2, mobile: 6 }}>
          <Radio
            error={error}
            omitFirstLine
            omitLastLine
            id="radio_no"
            onChange={() => toggleOnChange(false)}
            value={radioValue}
            options={[
              {
                disabled: isDisabled,
                value: 'no',
                label: noLabel || t('products-fe.general.no'),
              },
            ]}
          />
        </Column>
      </Row>
      <SpacerVertical spaceToken="space.200" />
      {error ? <ErrorMessage message={error} /> : null}
    </>
  );
};

Toggle.propTypes = {
  t: PropTypes.func.isRequired,
  toggleOnChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  noLabel: PropTypes.string,
  toggleValue: PropTypes.bool,
  yesLabel: PropTypes.string,
};

export default connect(state => ({
  t: translator(state),
}))(Toggle);
